'use es6';

import styled from 'styled-components';
import HorizontalEdgeToolbar from './HorizontalEdgeToolbar';
import { EDGE_TOOLBAR_HEIGHT } from './constants';

// Adjustment to "pull up" the rotated toolbar to the expected top left position
import { jsx as _jsx } from "react/jsx-runtime";
const TOP_ADJUSTMENT = -1 * EDGE_TOOLBAR_HEIGHT;
const VerticalEdgeToolbar = props => {
  let style = props.style;

  // If a custom top position is passed, make sure to combine it with the top adjustment, otherwise
  // it will be blown away by the overriding style
  if (style && style.top != null) {
    style = Object.assign({}, style, {
      top: style.top += TOP_ADJUSTMENT
    });
  }
  return /*#__PURE__*/_jsx(HorizontalEdgeToolbar, Object.assign({
    dropdownPlacement: "right"
  }, props, {
    style: style
  }));
};
const StyledVerticalEdgeToolbar = styled(VerticalEdgeToolbar).withConfig({
  displayName: "VerticalEdgeToolbar__StyledVerticalEdgeToolbar",
  componentId: "sc-1jnpzir-0"
})([".hs-private.hs-private.hs-private &{transform:rotate(270deg) translate(-100%,0);transform-origin:left bottom 0;position:relative;top:", "px;}"], TOP_ADJUSTMENT);
export default StyledVerticalEdgeToolbar;